(function () {
  'use strict';
  if (window.__willowSwymPdp) return;
  window.__willowSwymPdp = true;

  var initialized = false;
  var initAttempts = 0;
  var checkRequest = 0;
  var variantData = null;
  var REQUEST_TIMEOUT = 8000;

  function emit(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    var event = { event: eventName };
    Object.keys(payload || {}).forEach(function (key) { event[key] = payload[key]; });
    window.dataLayer.push(event);
  }

  function wishlistButtons() {
    return document.querySelectorAll('[data-wv-pdp-wishlist]');
  }

  function labelFor(button) {
    return button.querySelector('[data-wv-wishlist-label]');
  }

  function setBusy(button, busy) {
    if (busy) button.setAttribute('aria-busy', 'true');
    else button.removeAttribute('aria-busy');
  }

  function clearRequest(button) {
    if (button._wvWishlistTimer) clearTimeout(button._wvWishlistTimer);
    button._wvWishlistTimer = null;
    setBusy(button, false);
  }

  function update(button, selected) {
    clearRequest(button);
    button.classList.remove('is-unavailable', 'has-error');
    button.removeAttribute('aria-disabled');
    button.removeAttribute('title');
    button.classList.toggle('swym-added', selected);
    button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    button.setAttribute('aria-label', selected ? 'Remove from wishlist' : 'Add to wishlist');
    var label = labelFor(button);
    if (label) label.textContent = selected ? 'Saved to wishlist' : 'Save to wishlist';
  }

  function errorText(error) {
    if (!error) return 'Unknown error';
    return String(error.message || error.error || error);
  }

  function appIsDisabled(error) {
    return errorText(error).toLowerCase().indexOf('wishlist app is not enabled') !== -1;
  }

  function showError(button, error, phase) {
    clearRequest(button);
    var disabled = appIsDisabled(error);
    var label = labelFor(button);
    button.classList.add(disabled ? 'is-unavailable' : 'has-error');
    button.setAttribute('title', disabled ? 'Wishlist is not enabled for this theme yet.' : 'Wishlist could not be updated. Please try again.');
    if (disabled) {
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-label', 'Wishlist unavailable');
      if (label) label.textContent = 'Wishlist unavailable';
    }
    else {
      if (label) label.textContent = 'Try wishlist again';
      window.setTimeout(function () {
        if (button.getAttribute('aria-busy') === 'true' || button.classList.contains('is-unavailable')) return;
        button.classList.remove('has-error');
        update(button, button.getAttribute('aria-pressed') === 'true');
      }, 2600);
    }
    emit('willow_wishlist_error', {
      error_message: errorText(error),
      error_phase: phase || 'unknown'
    });
    if (window.console && console.warn) console.warn('[Willow wishlist]', phase || 'request', error);
  }

  function productFromPage() {
    var pageData = window.SwymPageData;
    if (!pageData || Number(pageData.et) !== 1) return null;
    return {
      epi: pageData.epi,
      empi: pageData.empi,
      du: pageData.du,
      dt: pageData.dt,
      iu: pageData.iu,
      pr: pageData.pr
    };
  }

  function readVariantData() {
    if (variantData) return variantData;
    var node = document.querySelector('[data-wv-pdp-variant-data]');
    if (!node) return {};
    try {
      variantData = JSON.parse(node.textContent || '{}');
    }
    catch (error) {
      variantData = {};
      if (window.console && console.warn) console.warn('[Willow wishlist] Could not read variant data', error);
    }
    return variantData;
  }

  function dispatchCompareVariant(button, previousKey) {
    var detail = { button: button, previousKey: previousKey };
    try {
      document.dispatchEvent(new CustomEvent('willow:compare-variant-changed', { detail: detail }));
    }
    catch (_) {
      var event = document.createEvent('CustomEvent');
      event.initCustomEvent('willow:compare-variant-changed', true, false, detail);
      document.dispatchEvent(event);
    }
  }

  function updateCompareVariant(variantId) {
    var data = readVariantData()[String(variantId)] || {};
    document.querySelectorAll('[data-wv-pdp-compare]').forEach(function (button) {
      var previousKey = String(button.dataset.handle || button.dataset.productId || '') + ':' + String(button.dataset.variantId || '');
      button.dataset.variantId = String(variantId);
      ['url', 'image', 'price', 'sku', 'eta'].forEach(function (name) {
        if (data[name] != null && data[name] !== '') button.dataset[name] = String(data[name]);
      });
      dispatchCompareVariant(button, previousKey);
    });
  }

  function init(swat) {
    var buttons = wishlistButtons();
    if (!buttons.length || initialized) return;

    var product = productFromPage();
    if (!product) {
      initAttempts += 1;
      if (initAttempts < 20) window.setTimeout(function () { init(swat); }, 250);
      else buttons.forEach(function (button) { showError(button, new Error('Wishlist product data is unavailable'), 'initialization'); });
      return;
    }

    initialized = true;

    function check() {
      var requestId = ++checkRequest;
      var requestedVariant = String(product.epi);
      var settled = false;
      var timer = window.setTimeout(function () {
        if (settled || requestId !== checkRequest) return;
        settled = true;
        buttons.forEach(function (button) { showError(button, new Error('Wishlist request timed out'), 'fetch'); });
      }, REQUEST_TIMEOUT);

      function success(items) {
        if (settled || requestId !== checkRequest) return;
        settled = true;
        clearTimeout(timer);
        if (String(product.epi) !== requestedVariant) return;
        var found = (items || []).some(function (item) {
          return String(item.empi) === String(product.empi) && String(item.epi) === requestedVariant;
        });
        buttons.forEach(function (button) { update(button, found); });
      }

      function failure(error) {
        if (settled || requestId !== checkRequest) return;
        settled = true;
        clearTimeout(timer);
        buttons.forEach(function (button) { showError(button, error || new Error('Wishlist could not be loaded'), 'fetch'); });
      }

      try {
        var result = swat.fetch(success, failure);
        if (result && typeof result.catch === 'function') result.catch(failure);
      }
      catch (error) {
        failure(error);
      }
    }

    buttons.forEach(function (button) {
      if (button.dataset.wvWishlistBound === 'true') return;
      button.dataset.wvWishlistBound = 'true';

      button.addEventListener('click', function () {
        if (button.getAttribute('aria-busy') === 'true' || button.getAttribute('aria-disabled') === 'true') return;

        var selected = button.getAttribute('aria-pressed') === 'true';
        var requestId = (button._wvWishlistRequest || 0) + 1;
        button._wvWishlistRequest = requestId;
        setBusy(button, true);

        var settled = false;
        function finishOnce(callback) {
          if (settled || button._wvWishlistRequest !== requestId) return;
          settled = true;
          clearRequest(button);
          callback();
        }

        var done = function () {
          finishOnce(function () {
            update(button, !selected);
            emit(selected ? 'willow_wishlist_remove' : 'willow_wishlist_add', {
              product_id: product.empi,
              variant_id: product.epi,
              customer_mode: window.SwymPageData && window.SwymPageData.custid ? 'customer' : 'guest'
            });
          });
        };

        var failed = function (error) {
          finishOnce(function () {
            showError(button, error || new Error('Wishlist could not be updated'), selected ? 'remove' : 'add');
          });
        };

        button._wvWishlistTimer = window.setTimeout(function () {
          failed(new Error('Wishlist request timed out'));
        }, REQUEST_TIMEOUT);

        try {
          var result = selected
            ? swat.removeFromWishList(product, done, failed)
            : swat.addToWishList(product, done, failed);
          if (result && typeof result.then === 'function') result.then(done, failed);
        }
        catch (error) {
          failed(error);
        }
      });
    });

    check();

    if (swat.evtLayer && swat.JSEvents && swat.JSEvents.variantChanged) {
      swat.evtLayer.addEventListener(swat.JSEvents.variantChanged, function (event) {
        var detail = event && event.detail && event.detail.d;
        var variantId = detail && detail.variant && detail.variant.id;
        if (!variantId) return;

        checkRequest += 1;
        buttons.forEach(function (button) {
          button._wvWishlistRequest = (button._wvWishlistRequest || 0) + 1;
          clearRequest(button);
        });

        var swymVariants = window.SwymProductVariants || {};
        var variant = swymVariants[variantId] || swymVariants[String(variantId)];
        var localVariant = readVariantData()[String(variantId)] || {};

        product.epi = variant && variant.epi ? variant.epi : variantId;
        if (variant) {
          product.pr = variant.pr != null ? variant.pr : product.pr;
          product.iu = variant.iu || product.iu;
        }
        if (localVariant.url) product.du = localVariant.url;
        if (localVariant.image) product.iu = localVariant.image;

        updateCompareVariant(variantId);
        check();
      });
    }
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(init);
  if (window._swat) init(window._swat);
})();
